<template>
  <div>
    <div class="content-container">
      <SidebarNav />
      <div>
        <h1>API test-side</h1>

        <select v-model="protocol">
          <option value="https">SSL</option>
          <option value="http">HTTP</option>
        </select>
        <select v-model="address">
          <option value="portal-api.getacademy.no">portal.getacademy.no</option>
          <option value="localhost:44313">localhost:44313</option>
        </select>
        <button @click="loadAll">Reload</button>

        <div>
          <h2>Bruker GUID</h2>
          <ul>
            <li>DB Guid: {{ userInfo.id }}</li>
            <li>Auth0Id: {{ authId }}</li>
          </ul>
        </div>

        <div id="all-students">
          <h2>Alle våre nydelige studenter!</h2>
          <table>
            <tr>
              <th>Navn</th>
              <th>Modul</th>
              <th>Fødselsdato</th>
              <th>Tlf.</th>
              <th>Bosted</th>
              <th>Om meg</th>
            </tr>
            <tr v-for="student in allStudents" v-bind:key="student.id">
              <td>{{ student.firstName }} {{ student.lastName }}</td>
              <td>{{ student.module.name }}</td>
              <td>
                {{ new Date(student.birthDate).getDate() }}/{{
                  new Date(student.birthDate).getMonth()
                }}/{{ new Date(student.birthDate).getFullYear() }}
              </td>
              <td>{{ student.telephone }}</td>
              <td>{{ student.city }}</td>
              <td><vue-showdown :markdown="student.userBio" /></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";
import SidebarNav from "@/components/SidebarNav.vue";
export default {
  name: "AdminPanel",
  data() {
    return {
      protocol: "https",
      address: "portal-api.getacademy.no",
      allStudents: [],
    };
  },
  components: {
    SidebarNav,
  },
  computed: {
    ...mapState(["userInfo"]),

    baseUrl() {
      return `${this.protocol}://${this.address}/api`;
    },

    authId() {
      return this.$auth.user.sub || null;
    },
  },
  async mounted() {
    await this.loadAll();
  },
  methods: {
    ...mapActions(["getUserInfo", "getToken"]),

    async loadAll() {
      this.getUserInfo();
      this.getAllStudents();
    },

    async getAllStudents() {
      await this.getToken();

      await axios
        .get(`${this.baseUrl}/candidate`, this.$store.getters.axiosConfig)
        .then((response) => {
          this.allStudents = response.data;
        });
    },

    getUserId() {
      this.userId = null;
      axios
        .get(`${this.baseUrl}/candidate/${this.$auth.user.sub}`)
        .then((response) => {
          console.log(`this.userId = ${response.data.userId}`);
          this.userId = response.data.userId;
          this.getUserInfo();
          this.getUserProjects();
        });
    },

    getUserInfo() {
      this.userInfo = null;
      axios
        .get(`${this.baseUrl}/candidate/${this.$auth.user.sub}`)
        .then((response) => {
          console.log(`this.userInfo = ${response.data}`);
          this.userInfo = response.data;
        });
    },

    getKeyCompetences() {
      this.keyCompetences = null;
      axios.get(`${this.baseUrl}/keycompetences`, {}).then((response) => {
        console.log(`this.keyCompetences = ${response.data}`);
        this.keyCompetences = response.data;
      });
    },

    getDisciplines() {
      this.disciplines = null;
      axios.get(`${this.baseUrl}/Disciplines`).then((response) => {
        console.log(`this.disciplines = ${response.data}`);
        return (this.disciplines = response.data);
      });
    },

    getTechnologies() {
      this.technologies = null;
      axios.get(`${this.baseUrl}/Technologies`).then((response) => {
        console.log(`this.technologies = ${response.data}`);
        return (this.technologies = response.data);
      });
    },

    getUserProjects() {
      this.userProjects = null;
      axios
        .get(`${this.baseUrl}/UserPortfolio/${this.userId}`)
        .then((response) => {
          console.log(`this.userProjects = ${response.data}`);
          return (this.userProjects = response.data);
        });
    },

    addUserProject() {
      axios
        .post(`${this.baseUrl}/UserPortfolio`, {
          UserId: this.userId,
          Link: this.linkPortfolioInput,
          Description: this.descriptionPortfolioInput,
          Title: this.titlePortfolioInput,
        })
        .then((response) => {
          this.portfolioAddedToDB = response.data;
          this.getUserProjects();
        });
    },

    addDisciplineToDB() {
      axios
        .post(`${this.baseUrl}/Disciplines`, {
          id: null,
          name: this.disciplineInput,
          dependson: this.disciplineDep,
        })
        .then((response) => {
          this.disciplineAddedToDB = response.data;
          this.getDisciplines();
        });
    },
  },
};
</script>

<style lang="scss" scoped>

.content-container {
  display: flex;
  flex-direction: row;
}

a {
  text-decoration: underline;
  color: #ff7715;
}

.success {
  color: green;
}

.error {
  color: red;
}

.columns {
  display: flex;
  gap: 2em;
}

.columns > * {
  flex-grow: 1;
  flex-basis: 0;
}

table {
  width: 100%;
}

table,
th,
td {
  border-collapse: collapse;
  border: 1px solid grey;
}

th,
td {
  padding: 10px;
}
</style>